import {serverCall} from "../../../http.ts";
import {SUB_ROLE_MODULE} from "@/redux/rtk/admin/settings/types";

export const getUserRoles = async () => {
    return await serverCall({
        type: "get",
        timeout: 1,
        endpoint: "/getUserRoles",
        apiDir: `webapi/shared`,
    }, null)
}

export const getRoleDetails = async (data) => {
    return await serverCall({
        type: "get",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/getRoleDetails",
        apiDir: `webapi/shared`,
    }, null)
}

export const getUserSubRoles = async (data) => {
    return await serverCall({
        type: "get",
        data: {
            ...data
        },
        timeout: 1,
        endpoint: "/getUserSubRoles",
        apiDir: `webapi/shared`,
    }, null)
}

export const createSubRole = async (data) => {
    return await serverCall({
        type: "post",
        data: {
            ...data
        },
        timeout: 1,
        endpoint: "/createSubRole",
        apiDir: `webapi/shared`,
    }, null)
}

export const editSubRole = async (data) => {
    return await serverCall({
        type: "put",
        data: {
            ...data
        },
        timeout: 1,
        endpoint: "/editSubRole",
        apiDir: `webapi/shared`,
    }, null)
}

export const deleteSubRole = async (data) => {
    return await serverCall({
        type: "delete",
        data: {
            ...data
        },
        timeout: 1,
        endpoint: "/deleteSubRole",
        apiDir: `webapi/shared`,
    }, null)
}

export const getMainModules = async (data) => {
    return await serverCall({
        type: "get",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/getMainModules",
        apiDir: `webapi/shared`,
    }, null)
}

export const updateSubRoleModules = async (data: SUB_ROLE_MODULE) => {
    return await serverCall({
        type: "put",
        timeout: 1,
        data: {
            ...data
        },
        endpoint: "/updateSubRoleModules",
        apiDir: `webapi/shared`,
    }, null)
}
